import { Button } from "@/components/ui/button.tsx";
import type { ContactEvent } from "@/types/contactActivity.ts";
import { CalendarDays, Repeat } from "lucide-react";

/** A single event row in the contact's Events tab. */
export const ContactEventRow = ({
  event,
  onOpen,
}: {
  event: ContactEvent;
  onOpen: (eventId: string) => void;
}) => {
  const Icon = event.isRecurring ? Repeat : CalendarDays;
  const subtitle = [event.formattedRange, event.location].filter(Boolean).join(" · ");
  return (
    <Button
      variant="ghost"
      data-statsig-name="contact-event-row"
      onClick={() => onOpen(event.eventId)}
      className="flex h-auto w-full items-center justify-start gap-2.5 rounded-xl px-2 py-2 text-left"
    >
      <Icon className="size-3.5 shrink-0 text-muted-foreground" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm">{event.summary || "(no title)"}</span>
        {subtitle && (
          <span className="truncate text-xs font-normal text-muted-foreground">{subtitle}</span>
        )}
      </div>
    </Button>
  );
};
